import { render } from "./unAuthorized.vue?vue&type=template&id=5632a61a&scoped=true"
import script from "./unAuthorized.vue?vue&type=script&lang=js"
export * from "./unAuthorized.vue?vue&type=script&lang=js"

import "./unAuthorized.vue?vue&type=style&index=0&id=5632a61a&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5632a61a"]])

export default __exports__